import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import bgImage from "./images/BG.png";
import LivePopout from "./components/LivePopout/LivePopout";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import HomePage from "./pages/HomePage/HomePage";
import AboutPage from "./pages/AboutPage/AboutPage";
import CSR from "./pages/CSR/CSR";
import Support from "./pages/Support/Support";

function AppContent() {
  const location = useLocation();
  const liveSrc = location.pathname === "/csr"
    ? "https://www.tiktok.com/embed/live/@csr2640"
    : "https://www.tiktok.com/embed/live/@cuatro.bodroex";

  return (
      <div
        className="min-h-screen text-white"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
        }}
      >
        <div style={{ backgroundColor: "rgba(0,0,0,0.7)", minHeight: "100vh" }}>
          <Navbar />
          <LivePopout src={liveSrc} />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/csr" element={<CSR />} />
            <Route path="/support" element={<Support />} />
          </Routes>
          <Footer />
        </div>
      </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}
